import { render } from "./Models.vue?vue&type=template&id=19de6247&scoped=true"
import script from "./Models.vue?vue&type=script&lang=js"
export * from "./Models.vue?vue&type=script&lang=js"

import "./Models.vue?vue&type=style&index=0&id=19de6247&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19de6247"]])

export default __exports__